import { useRef } from 'react'

import { useEffectOnce } from 'react-use'

import { ModalAPI, createModal } from './GlobalModal/globalModal.helper'
import { ModalComponent, ModalCompositeOption } from './types'

export const useModal = <T extends {}>(
  ModalComponent: ModalComponent<T>,
  defaultOptions?: ModalCompositeOption<T>,
): ModalAPI<T> => {
  const modalRef = useRef<ModalAPI<T>>()

  useEffectOnce(() => {
    modalRef.current = createModal(ModalComponent, defaultOptions, false)
    return () => modalRef.current?.removeModal()
  })

  return {
    closeModal: () => modalRef.current?.closeModal(),
    modalId: modalRef.current?.modalId ?? -1,
    openModal: options => modalRef.current?.openModal({ ...defaultOptions, ...options } as ModalCompositeOption<T>),
    removeModal: () => modalRef.current?.removeModal(),
    updateModal: options => modalRef.current?.updateModal(options),
  }
}
